import { createEntityByIdSource } from 'serviceWorker/channelServers/entitySource';
import * as dbCompanies from 'serviceWorker/db/companies/companies';
import * as dbContracts from 'serviceWorker/db/contracts/contracts';
import * as dbContractsService from 'serviceWorker/db/contracts/contractsService';
import { contractEntityToModel } from 'serviceWorker/repository/contract/mapping';
import { getCurrentUsers } from 'serviceWorker/services/users/getUsers';
import { contractChannelContract } from 'shared/domain/contract/contractChannelContract';
import { contractsSync } from './index';

/**
 * Contracts of IndexedDB; the collection holds the active ones, `getOneById`
 * deleted ones too. Party labels come from the stored companies and users as
 * they are (as the legacy reads did): a missing download must not block them.
 */
export const contractSource = createEntityByIdSource({
  service: dbContractsService,
  contract: contractChannelContract,
  ...contractsSync,
  readAll: async () => {
    const [contracts, companies, users] = await Promise.all([dbContracts.get(), dbCompanies.get(), getCurrentUsers()]);
    return contracts.map((contract) => contractEntityToModel(contract, companies, users));
  },
  readOne: async (id) => {
    const [contract, companies, users] = await Promise.all([
      dbContracts.getOne(id),
      dbCompanies.get(),
      getCurrentUsers(),
    ]);
    return contract && contractEntityToModel(contract, companies, users);
  },
});
